"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delay = void 0;
/**
 *
 * @param ms
 * @returns {Promise<unknown>}
 */
var delay = function delay(ms) {
  return new Promise(function (res) {
    return setTimeout(res, ms);
  });
};
exports.delay = delay;